import * as api from '../api';
import { formatNumber, recalculate, roundTwoDecimals, getCdnImageUrl} from "../functions";
import { childrenModal } from "./modal";

if ($('body').hasClass('type-product')) {

	var subscriptionCard = function(items) {
		var result = '';

		for (var i = 0; i < items.length; i++) {
			result += `
			<div class="subscription-card ${i === 0 ? 'active' : ''}" data-discount="${items[i].discount}" data-price="${items[i].priceWithDiscount}" data-quantity="${items[i].quantity}">
				<p class="sub-count"><span>${i+1}</span> ks</p>
				<p class="sub-price"><span>${formatNumber(items[i].totalPrice)}</span> Kč/obj</p>
				<p class="sub-price-one"><span>${formatNumber(items[i].priceWithDiscount)}</span> Kč/ks</p>
			</div>`
		}

		return result;
	}

	var render = function (items) {
		if(dataLayer[0].shoptet.currency !== 'CZK') return '';
		return `<div class="test-container">
		<!--   ZAČÁTEK HTML     -->
	        <div id="subscription-box">
	            <div class="sub-header">
	           
	                <h4>Předplatné <a href="/predplatne-homebox/"><img src="${getCdnImageUrl(`/user/documents/upload/predplatne/logo-wide.svg`)}" class="homebox-logo" /></a></h4>
	                
	                <a href="/predplatne-homebox/" class="more-info">Více informací</a>
	            </div>
	            <div id="subscription-cards">
		            ${subscriptionCard(items)}
	            </div>
	            <button type="button" class="more" id="show-more-quantity"><span>Zobrazit vše</span><span>Méně</span></button>
	            <div id="subscription-price-wrapper">
	                <div class="subscription-price-box">
	                    <p class="sub-price-main"><span class="main-price-span">${formatNumber(items[0].priceWithDiscount)}</span><span> Kč</span> / obj</p>
	                    <p class="sub-price-main-one">
	                        <span class="main-price-one-span">${formatNumber(items[0].priceWithDiscount)}</span> Kč/ks 
	                        <span class="sub-discount" style="display: ${items[0].discount > 0 ? 'inline' : 'none'}">Sleva ${items[0].discount.toFixed(0)} %</span>
	                    </p>
	                </div>
	                <div class="subscription-confirm-box">
	                    <button type="button" id="subscription-add" class="subscription-button">Přidat do předplatného</button>
	                </div>
	            </div>
	        </div>
				<!--   KONEC HTML     -->  
	    </div>`;
	}

	api.getData(
		"discount-by-product-code",
		{ code: dataLayer[0].shoptet.product.code }
	).done(function (data) {
		if (!data.enable) return;
		var items = [];
		var price = $('#product-detail .action-price').length > 0 ? parseFloat($('#product-detail .td-normal-price span').text().replace(' ', '').replace(',', '.')) : dataLayer[0].shoptet.product.priceWithVat;
		var discount = 0;

		for (var i = 1; i <= 12; i++) {
			discount = data.globalDiscount; // reset discount
			data.quantityDiscount.forEach(function (val) {
				if (i >= val.from && i <= val.to) {
					discount = val.percent;
				}
			});
			var priceWithDiscount = roundTwoDecimals(price - (price * discount) / 100);
			items.push({
				price,
				discount,
				priceWithDiscount,
				totalPrice: priceWithDiscount*i,
				quantity: i
			})
		}

		$('#product-detail').after(render(items));
		$('body').append(childrenModal())
		// $('.td-additional-price').after(`<div id="p-sub-wrapper"><p class="p-sub-price">od <span>${items[items.length-1].priceWithDiscount}</span> Kč <span class="p-sub-small"> </span></p><span>při využití předplatného HomeBox</span></div>`)
		var date = new Date();
		date.setDate(date.getDate() - 1);
		$('#sub-add-date').attr('max', date.toISOString().split("T")[0]);

	});
}

$(document).on('click', '#subscription-add', function () {
	$('#sub-overlay').show();
});
$(document).on('click', '#subscription-cards .subscription-card', function () {
	var price = $(this).data('price');
	var quantity = $(this).data('quantity');
	var discount = $(this).data('discount');

	$('.subscription-card').removeClass('active');
	$(this).addClass('active');
	$('.main-price-span').text(recalculate(price, quantity))
	$('.main-price-one-span').text(formatNumber(price));
	if (discount > 0) {
		$('.sub-discount').show();
		$('.sub-discount').text('Sleva ' + discount.toFixed(0) + '%');
	} else {
		$('.sub-discount').hide();
	}
	$('#add-subscription-form [name="quantity"]').val(quantity);
});

$(document).on('click', '#show-more-quantity', function (e) {
	e.preventDefault();
	$("#subscription-cards").toggleClass("visible");
	$(this).toggleClass("text-changer");
})


